<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="1800">
    <v-card>
      <ODialogBar title="Mini-Parser" @close="$refs.dialog.$dismiss()" />
      <v-card-text class="maxh-8">
        <ORow fill-x top>
          <MiniParser :value="initialValue" />
          <ProtocolHelp type="lapse" />
        </ORow>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import MiniParser from './MiniParser.vue'
import ProtocolHelp from './ProtocolHelp.vue'

export default {
  components: { MiniParser, ProtocolHelp },
  data() {
    return {
      initialValue: null
    }
  },
  methods: {
    open(value) {
      this.initialValue = value
      return this.$refs.dialog.$open()
    }
  }
}
</script>

<style></style>
